<div class="default-dialog-wrapper mat-elevation-z10">
  <div class="flex flex-row content pt-20 pr-24 pb-20 pl-24">
    <div class="flex flex-col w-100-percent">
      <div *ngIf="!secondaryRegion && !warning && !infraWarning" class="flex flex-row w-100-percent">
        <h1 class="flex flex-wrap basis-full mat-headline-5 mb-14 fw-700 mr-98">{{title}}</h1>
        <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
      </div>
      <div *ngIf="confirmationTitle" class="mb-24 mat-subtitle-2 fw-500">{{confirmationTitle}}</div>
      <ng-container *ngIf="optionSelection?.length > 0">
        <div class="flex flex-row self-start mb-16 mat-subtitle-2 fw-500">
          <div *ngFor="let option of optionSelection" class="flex flex-row mr-32">
            <mat-icon [svgIcon]="option.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-4" (click)="selectOptions(option)"></mat-icon>
            {{option.label | titlecase}}
          </div>
        </div>
      </ng-container>
      <div *ngIf="!optionSelection && !secondaryRegion && !warning && !infraWarning" class="mat-subtitle-2 fw-500 tracking-normal mr-24" [ngClass]="{'mb-12': page === 'baseImage', 'mb-16': page !== 'baseImage', 'sub-position': !note && page !== 'sizingApply' && page !== 'baseImageRollback' && !summary1 && !summary2, 'rollback-message': page === 'baseImageRollback'}">
        <span [innerHtml]="message"></span>
        <span *ngIf="scheduleName && scheduleName !== ''" class="fw-700" [innerHtml]="scheduleName"></span>
      </div>
      <div *ngIf="!optionSelection && note && !noteWithBg && !noteTextColor && !noteSizing" class="fw-400 tracking-normal mr-24" [ngClass]="page === 'baseImage' ? 'fs-14' : 'mt-12 fs-12'" [innerHtml]="note"></div>
      @if (page === 'baseImageRollback') {
        <div class="flex flex-col mb-12 rollback">
          <div class="flex flex-row fs-16 fw-400">
            <div>{{'BLUEPRINT_SUMMARY.IMAGE_NAME' | transloco}} :</div>
            <div class="pl-12">{{imageName}}</div>
          </div>
          <div class="flex flex-row">
            <div>{{'BLUEPRINT_SUMMARY.UPDATED_ON' | transloco}} &nbsp;:</div>
            <div class="pl-12">{{updatedOn}}</div>
          </div>
        </div>
      }
      <div *ngIf="noteWithBg" class="fs-14 fw-500 p-8 bg flex mt-12 mb-8">
        <mat-icon svgIcon="error_outline" class="icon-md mr-8 icon" [matDialogClose]="false"></mat-icon>
        <span>{{'BLUEPRINT_SUMMARY.NOTE' | transloco}}<span class="ml-2">{{note}}</span></span>
      </div>
      <div *ngIf="noteTextColor" class="fs-14 fw-500 mt-12 mb-12 mr-32">
        <span class="note-color">{{'BLUEPRINT_SUMMARY.NOTE' | transloco}}</span><span class="ml-2">{{note}}</span>
      </div>
      <div *ngIf="summary1 || summary2" class="flex flex-col mb-16">
        <div class="mat-subtitle-2 fw-500 mb-8">{{'BLUEPRINT_SUMMARY.SUMMARY_NOTE' | transloco}}</div>
        <div class="table-border">
          <table class="summary-table">
            <tr *ngIf="summary1">
              <td class="fw-500 fs-16">{{'BLUEPRINT_SUMMARY.SERVICE_DEF_NOTE' | transloco}}</td>
              <td class="fw-500 fs-16">{{'BLUEPRINT_SUMMARY.VERSION_NOTE' | transloco}} {{summary1}}</td>
            </tr>
            <tr *ngIf="summary2">
              <td class="fw-500 fs-16">{{'BLUEPRINT_SUMMARY.SIZING_DOC_NOTE' | transloco}}</td>
              <td class="fw-500 fs-16">{{summary2}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div *ngIf="ticketIdField" class="flex flex-col mb-24">
        <form [formGroup]="ticketForm">
          <div class="flex flex-row">
            <span class="mat-subtitle-2 fw-700 fs-12 mb-2">{{page === 'sizingApply'? ('SIZING.TICKET_NUMBER'| transloco | uppercase) : ('EDGE_NETWORK_DETAILS.TICKET_ID' | transloco | uppercase) }}</span>
          </div>
          <input formControlName="ticketNumber" placeholder="{{page === 'sizingApply'? ('SIZING.TICKET_NUMBER' | transloco) : ('EDGE_NETWORK_DETAILS.TICKET_ID' | transloco)}}" class="fw-400 h-48 fs-14 input-box" required id="ticket" (input)="ticketIdChange($event)">
          <app-error [control]="ticketForm.get('ticketNumber')"></app-error>
        </form>
      </div>
      <div *ngIf="noteSizing && note" class="note-dashed fs-14 fw-500 mb-16">
        <span class="fw-700">{{'BLUEPRINT_SUMMARY.NOTE' | transloco}} </span>{{note}}
      </div>
       <div *ngIf="secondaryRegion" class="flex flex-col mb-32">
        <div class="flex flex-row mt-16 mb-14 justify-center items-center">
            <mat-icon svgIcon="warning_amber" class="w-40 h-40 amber_color"></mat-icon>
        </div>
        <div class="flex flex-row mat-subtitle-2 fw-500 fs-16 mb-12 justify-center items-center" [innerHTML]="'TENANT_FORM.SECONDARY_WARN' | transloco"></div>
        <div *ngIf="secondaryRegion && !secondaryMsg; else secondMsg" class="fw-400 fs-14 pl-8 pr-8 pt-16 pb-16 secondary-mesage" [innerHTML]="'TENANT_FORM.SECONDARY_MESSAGE' | transloco"></div>
        <ng-template #secondMsg>
          <div class="fw-400 fs-14 pl-8 pr-8 pt-16 pb-16 secondary-mesage" [innerHTML]="'TENANT_FORM.SECONDARY_MSG' | transloco"></div>
        </ng-template>
      </div>
      @if(warning) {
        <div class="flex flex-col mb-32">
        <div class="flex flex-row mt-16 mb-14 justify-center items-center">
            <mat-icon svgIcon="warning_amber" class="w-40 h-40 amber_color"></mat-icon>
        </div>
        <div class="flex flex-row mat-subtitle-2 fw-500 fs-16 mb-12 justify-center items-center text-center" [innerHtml]="title"></div>
        <div class="fw-400 fs-14 pl-8 pr-8 pt-16 pb-16 secondary-mesage"  [innerHtml]="message"></div>
      </div>
      }
       @if(infraWarning) {
        <div class="flex flex-col mb-32">
          <div class="flex flex-row mt-16 justify-end">
            <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
        </div>
        <div class="flex flex-row mb-14 justify-center items-center">
            <mat-icon svgIcon="warning_amber" class="w-40 h-40 amber_color"></mat-icon>
        </div>

        <div class="flex flex-row mat-subtitle-2 fw-700 fs-16 justify-center items-center text-center" [innerHtml]="title"></div>
        <div class="fw-400 fs-14 pl-8 pr-8 pb-16 justify-center items-center text-center"  [innerHtml]="message"></div>
      </div>
      }
      <mat-divider class="neutral-blue-7 w-100-percent mt-4 mb-4"></mat-divider>
      <div class="flex flex-row justify-end w-100-percent mt-16">
        <button class="white mr-12" [matDialogClose]="false">{{cancelButtonText}}</button>
        <button class="accent" (click)="dialogClose()">{{confirmButtonText}}</button>
      </div>
    </div>
  </div>
</div>
